<template>
  <v-col>
    <v-textarea
      v-model="announcement"
      :error-messages="errors.getMessage('announcement')"
    />
    <v-btn
      class="info mt-3"
      @click="announcementUpdate"
    >
      Update announcement
    </v-btn>
  </v-col>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      announcement: "",
    };
  },
  computed: {
    ...mapGetters({
      main: "configs/overall",
      errors: "validation/pull",
    }),
  },
  mounted() {
    const data = this.main.announcement;
    if (data !== null) {
      this.$data.announcement = data;
    }
  },
  methods: {
    announcementUpdate() {
      Event.$emit("updateConfigs", {
        path: "setting-announcement",
        payload: { announcement: this.announcement },
      });
    },
  },
};
</script>
